export default function extractInput (componentElement, props, data, obj) {
    const input = componentElement.querySelector('.x-answer-input');
    if(!input) return {};
    const answer_value = input.value ?? '';
    if(obj.mode==1){
        return {
            correct_answer: answer_value
        }    
    } else {
        return {
            answer: answer_value
        }            
    }
}